import { paymentStatuses } from "../../../../utilities/helpers";

import { Row } from "./Row";

export default function EventAssignTable({ orders, setOrders, runSearch }) {
  return (
    <div
      className="list-table list-table--with-inside-borders list-table--with-border list-table--with-bg list-table--with-radius list-table--assign-tickets two-col"
      role="table"
    >
      <div className="flex-row list-table-header" role="rowgroup">
        <div
          className="list-table-col text-center list-table-col-header list-table-col-header--dark lg"
          role="columnheader"
        >
          <span>Organization</span>
        </div>
        <div
          className="list-table-col list-table-col-header list-table-col-header--dark"
          role="columnheader"
        >
          <span>Email</span>
        </div>
        <div
          className="list-table-col list-table-col-header list-table-col-header--dark sm"
          role="columnheader"
        >
          <span>Section</span>
        </div>
        <div
          className="list-table-col list-table-col-header list-table-col-header--dark sm"
          role="columnheader"
        >
          <span>Row</span>
        </div>
        <div
          className="list-table-col list-table-col-header list-table-col-header--dark sm"
          role="columnheader"
        >
          <span>Seats</span>
        </div>
        <div
          className="list-table-col list-table-col-header list-table-col-header--dark sm"
          role="columnheader"
        >
          <span>Total amount</span>
        </div>
        <div
          className="list-table-col list-table-col-header list-table-col-header--dark sm"
          role="columnheader"
        >
          <span>Amount due</span>
        </div>
        <div
          className="list-table-col list-table-col-header sm text-center list-table-col-header--dark"
          role="columnheader"
        >
          <span>Status</span>
        </div>
        <div
          className="list-table-col list-table-col-header sm text-center list-table-col-header--dark"
          role="columnheader"
        >
          <span>Tickets sent</span>
        </div>
      </div>
      {orders &&
        orders?.map((order, idx) => (
          <Row
            key={idx}
            order={order}
            setOrders={setOrders}
            status={paymentStatuses[order.status]}
            runSearch={runSearch}
          />
        ))}
    </div>
  );
}
